import React, { createContext, useState } from 'react'

export const LayoutContext = createContext()

const LayoutContextProvider = ({ children }) => {
    const [panelOpen, setPanelOpen] = useState(false)
    const [basketPanel, setBasketPanel] = useState(false)
    const [signInPanel, setSignInPanel] = useState(true)
    const [orderPanel, setOrderPanel] = useState(false)
    const [accountPanel, setAccountPanel] = useState(false)
    const [goToSubscription, setGoToSubscription] = useState(false)

    const openPanel = (value, goToSection) => {
        switch (value) {
            case 'basketPanel':
                setSignInPanel(false)
                setOrderPanel(false)
                setAccountPanel(false)
                setBasketPanel(true)
                setGoToSubscription(false)
                return setPanelOpen(true)
            case 'signInPanel':
                setBasketPanel(false)
                setOrderPanel(false)
                setAccountPanel(false)
                setSignInPanel(true)
                setGoToSubscription(false)
                return setPanelOpen(true)
            case 'orderPanel':
                setBasketPanel(false)
                setSignInPanel(false)
                setAccountPanel(false)
                setOrderPanel(true)
                setGoToSubscription(false)
                return setPanelOpen(true)
            case 'accountPanel':
                setBasketPanel(false)
                setSignInPanel(false)
                setOrderPanel(false)
                setAccountPanel(true)
                if (goToSection === 'subscription') setGoToSubscription(true)
                return setPanelOpen(true)
            default:
                return setPanelOpen(true)
        }
    }
    const closePanel = () => {
        setGoToSubscription(false)
        return setPanelOpen(false)
    }

    const contextValues = {
        accountPanel,
        basketPanel,
        closePanel,
        openPanel,
        orderPanel,
        panelOpen,
        signInPanel,
        goToSubscription,
    }
    return <LayoutContext.Provider value={contextValues}>{children}</LayoutContext.Provider>
}
export default LayoutContextProvider
